import React from "react";
import { MailIcon } from "lucide-react";
import { Chat } from "@mui/icons-material";

/**
 * Single source of truth for all notification options.
 * Visibility per context allows showing different lists in root vs call menu business/after hours if needed.
 *
 * Contexts:
 * - root: Primary notification (ConfigureNotificationMainModal)
 * - callMenuBusinessHours: During business hours notification
 * - callMenuAfterHours: After hours notification
 */
export const NOTIFICATION_OPTIONS = [
  {
    type: "email",
    title: "Email Notification",
    subtitle: "send email alerts",
    icon: <MailIcon className="text-blue-500 mr-2" />,
    showInRoot: true,
    showInCallMenuBusinessHours: true,
    showInCallMenuAfterHours: true,
  },
  {
    type: "slack",
    title: "Slack Notification",
    subtitle: "send slack messages",
    icon: <img src="/icons/slack.png" alt="" className="text-blue-500 mr-2 w-[25px] h-[25px]" />,
    showInRoot: true,
    showInCallMenuBusinessHours: true,
    showInCallMenuAfterHours: true,
  },
  {
    type: "sms",
    title: "SMS Notification",
    subtitle: "send text messages",
    icon: <Chat className="text-green-500" />,
    showInRoot: true,
    showInCallMenuBusinessHours: true,
    showInCallMenuAfterHours: true,
  },
  {
    type: "front",
    title: "Front Notification",
    subtitle: "create front tickets",
    icon: <img src="/icons/front.png" alt="" className="text-blue-500 mr-2 w-[35px] h-[35px]" />,
    showInRoot: true,
    showInCallMenuBusinessHours: true,
    showInCallMenuAfterHours: true,
  },
];

const CONTEXT_FLAGS = {
  root: "showInRoot",
  callMenuBusinessHours: "showInCallMenuBusinessHours",
  callMenuAfterHours: "showInCallMenuAfterHours",
};

/**
 * Returns notification options for a given context.
 * @param {"root"|"callMenuBusinessHours"|"callMenuAfterHours"} context
 * @returns {Array<{ type: string, title: string, subtitle: string, icon: React.ReactNode }>}
 */
export function getNotificationOptionsForContext(context) {
  const flag = CONTEXT_FLAGS[context];
  if (!flag) return [];
  return NOTIFICATION_OPTIONS.filter((n) => n[flag]).map((n) => ({
    type: n.type,
    title: n.title,
    subtitle: n.subtitle,
    icon: n.icon,
  }));
}
